import React from 'react';

import PropTypes from 'prop-types';

import { BasicCheckbox } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import {BasicQueryCheckboxStore} from 'core/stores';

function BasicQueryCheckboxTemplate({
    id,
    queryUtility,
    propertyName,
    label,
    onChange,
    checked,
    store,
    disabled
}) {

    const handleChange = 
        onChange || ((event) => {
            const value = event.target.checked;
            queryUtility.filter.toggle(propertyName);
            store.setValue(value);
        });
    
        const value = checked || !!queryUtility.filter[propertyName];
        store.setValue(value);

    return (
        <BasicCheckbox
            type='checkbox'
            className='input--check check-fix'
            id={id}
            onChange={handleChange}
            checked={store.value}
            label={label}
            disabled={disabled}
        />
    );
}

BasicQueryCheckboxTemplate.propTypes = {
    id: PropTypes.string,
    queryUtility: PropTypes.object,
    propertyName: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    checked: PropTypes.any,
    disabled: PropTypes.bool,
    t: PropTypes.func,
    store: PropTypes.instanceOf(BasicQueryCheckboxStore)
};

export default defaultTemplate(BasicQueryCheckboxTemplate);
